"use strict";


var tabsArray = [];

function bsFormBuilder(options) {

	this.options = options;
	if (!('maxColumns' in this.options)) this.options.maxColumns = 12;
	if (!('size' in this.options)) this.options.size = 'small';
	if (!('sizeFactors' in this.options)) this.options.sizeFactors = { small: 2, large: 1 };
	else {
		if (!('small' in this.options.sizeFactors)) this.options.sizeFactors.small = 2;
		if (!('large' in this.options.sizeFactors)) this.options.sizeFactors.large = 1;
	}
	if (this.options.fields === 'undefined') this.options.fields = [];
	for (var key in this.options.fields) {
		var fld = this.options.fields[key];


		if (!('range' in fld)) fld.range = false;
		if (typeof fld?.range == 'number') fld.range = Boolean(fld.range);

		if (!('multiple' in fld)) fld.multiple = false;
		if (typeof fld?.multiple == 'number') fld.multiple = Boolean(fld.multiple);

		if (!('searchable' in fld)) fld.searchable = false;
		if (typeof fld?.searchable == 'number') fld.searchable = Boolean(fld.searchable);

		if (!('selectall' in fld)) fld.selectall = false;
		if (typeof fld?.selectall == 'number') fld.selectall = Boolean(fld.selectall);

		if (!('remote' in fld)) fld.remote = false;
		if (typeof fld?.remote == 'number') fld.remote = Boolean(fld.remote);

		if (!('subtext' in fld)) fld.subtext = false;
		if (typeof fld?.subtext == 'number') fld.subtext = Boolean(fld.subtext);

		if (!('maxheight' in fld)) fld.maxheight = 5;
		if (!('type' in fld)) fld.type = 'text'; else fld.type = fld.type.toLowerCase();
		switch (fld.type) {
			case "text":
				if (!('size' in fld)) fld.size = 3;
				break;
			case "number":
			case "date":
				if (!('size' in fld)) fld.size = fld.range ? 4 : 2;
				break;
			case "select":
			case "chosen":
			case "bootstrap-select":
				if (!('size' in fld)) fld.size = 3;
				if (!('name' in fld)) fld.name = fld.id + (fld.multiple ? "[]" : "");
				break;
			default:
				break;
		}
		if (!('size' in fld)) fld.size = 2;
		if (!('defaultlookupvals' in fld)) fld.defaultlookupvals = undefined;
		if (!('name' in fld)) fld.name = fld.id;
		if (!('help' in fld)) fld.help = fld.id;
		if (!('title' in fld)) fld.title = '';
		if (!('placeholder' in fld)) fld.placeholder = '';
		if (!('rowbreak' in fld)) fld.rowbreak = ''; else fld.rowbreak = fld.rowbreak.toLowerCase();
		if (!('lookupurl' in fld)) fld.lookupurl = '';
		if (!('lookupvals' in fld)) fld.lookupvals = [];
		if (!('resultorder' in fld)) fld.resultorder = undefined;
		this.options.fields[key] = fld;
	}
} 

bsFormBuilder.prototype.noFloatingAsterisk = function (e) {

	if (e.target.placeholder.indexOf("*") > -1) {
		var id = '#' + $(e.target).attr("id");
		var attr = $(id).attr("data-toggle");
		if ($(e.target).val().substring(0, 1) === "*") {
			if (typeof attr !== typeof undefined && attr !== false) {
			} else {
				$(id).attr("data-toggle", "tooltip");
				$(id).attr("data-placement", "bottom");
				$(id).attr("title", "Wildcard * is not allowed as the first character.");
				$(id).tooltip('show');
			}
		} else {
			if (this.value.substring(0, 1) !== "*") {
				if (typeof attr !== typeof undefined && attr !== false) {
					$(id).tooltip('dispose');
					$(id).removeAttr("data-toggle");
					$(id).removeAttr("data-placement");
					$(id).removeAttr("data-original-title");
					$(id).removeAttr("title");
				} else {
				}
			}
		}
	}
};

bsFormBuilder.prototype.numbersOnly = function (e) {
	if (e.charCode >= 48 && e.charCode <= 57)
		return true;
	else if (e.charCode >= 35 && e.charCode <= 40)
		return true;
	else {
		switch (e.charCode) {
			case 8:
			case 9:
			case 13:
			case 27:
			case 45:
			case 46:
			case 110:
			case 190:
				return true;
			default:
				return false;
		}
	}
}; 

bsFormBuilder.prototype.replaceSelectOptions = function ($select, list) {
	if ((typeof list !== 'object') || (list === null)) return;
	if ((!('length' in list)) || (list.length === 0)) return;

	var subtext = ($select.attr('data-show-subtext') === 'true');
	var picker = $select.hasClass('selectpicker');
	var text;
	var value;
	var id;

	$select.find('option').remove().end().val('');

	var dattr = $select.attr('data-default-selected');

	for (var i in list) {
		var item = list[i];

		if ('text' in item) text = item['text'];
		else if ('1' in item) text = item['1'];
		else text = '';
		if ('value' in item) value = item['value'];
		else if ('0' in item) value = item['0'];
		else value = text;

		if ((!!text) && (!!value)) {
			if ($select[0].id) {
				id = $select[0].id;
				var selected = false;
				if (sessionStorage && sessionStorage.getItem(id)) {
					var storedNames = JSON.parse(sessionStorage.getItem(id));
					if ($.isArray(storedNames)) {
						if ($.inArray(value, storedNames) > -1) {
							selected = true;
						}
					}
				} else {

					if (dattr) {
						var dattrs = dattr.split(';');
						dattrs.forEach(function (entry) {
							if (entry === value) {
								selected = true;
								return; 
							}
						});
					}

				}
			}
			if (subtext) {
				if (picker)
					$select.append($("<option></option>")
						.attr("value", value)
						.attr("data-subtext", value)
						.text(text));
				else
					$select.append($("<option></option>")
						.attr("value", value)
						.text(text + " (" + value + ")"));
			} else {
				$select.append($("<option></option>")
					.attr("value", value)
					.text(text));

				if (selected) {

					$select.find("option[value='" + value + "']").prop('selected', true);

				}
			}
		}
	}
	if ($select.hasClass("selectpicker")) $select.selectpicker('refresh');
	if ($select.hasClass("chosen")) $select.trigger("chosen:updated");
}; 

bsFormBuilder.prototype.fetchLookups = function ($select, fld) {
	var me = this;
	if ((typeof fld.lookupurl == 'string') && (fld.lookupurl.length > 0)) {
		if (fld.remote) {
			$select.ajaxSelectPicker({
				ajax: {
					url: fld.lookupurl,
					type: 'POST',
					dataType: 'json',
					data: { q: '{{{q}}}' }
				},
				preserveSelected: true,
				preserveSelectedPosition: 'before',
				preprocessData: function (data) {
					var subtext = ($select.attr('data-show-subtext') === 'true');
					if (subtext) {
						var len = data.length;
						for (var i = 0; i < len; i++) {
							data[i].data = { 'subtext': data[i].value };
						}
					}
					return data;
				},
			});
		} else {
			$.getJSON(fld.lookupurl, {
				format: "json"
			})
				.fail(function (jqXHR, textStatus, errorThrown) {
					var err = textStatus + ", " + errorThrown;
					console.log("Error: " + err + " processing " + fld.lookupurl);
				})
				.done(function (data) {
					me.replaceSelectOptions($select, data);
				});
		}
	}
}; 

bsFormBuilder.prototype.createField = function (fld) {

	var $elem = $("<div>", {
		"class": 'col-md-' + fld.size +
			' col-sm-' + Math.round(fld.size * this.options.sizeFactors.small) +
			' col-lg-' + Math.round(fld.size * this.options.sizeFactors.large)
	});

	var inputClass = 'form-control';
	var helpClass = 'help';
	var inputGroupClass = "";
	var $input = "";
	var $select = "";
	var $div = "";
	var $i1 = "";
	var $divApd = "";
	var $s = "";
	var $i = "";
	var $i2 = "";
	switch (this.options.size) {
		case "small":
			inputClass += " form-control-sm input-sm";
			inputGroupClass = "input-group-sm";
			helpClass += " col-form-label-sm";
			break;
		case "large":
			inputClass += " form-control-sm input-lg";
			inputGroupClass = "input-group-lg";
			helpClass += " col-form-label-lg";
			break;
	} 

	var highlightCriteria = '';
	var historyValue = '';
	if (sessionStorage && sessionStorage.getItem(fld.id)) {
		highlightCriteria = ' highlightCriteria';
		historyValue = sessionStorage.getItem(fld.id);
	}

	var data_default_selected = "";
	if (fld.defaultlookupvals == undefined) {
	} else {
		data_default_selected = fld.defaultlookupvals;
	}

	var placeholder = fld.placeholder;

	switch (fld.type) {
		case "number":
			if (fld.range) {
				highlightCriteria = '';
				historyValue = '';
				if (sessionStorage && sessionStorage.getItem(fld.id + '1')) {
					highlightCriteria = ' highlightCriteria';
					historyValue = sessionStorage.getItem(fld.id + '1');
				}
				$div = $("<div>", { 'class': 'input-group ' + inputGroupClass + ' nowrap' });
				$i1 = $("<input>", {
					'type': 'text',
					'class': inputClass + highlightCriteria,
					'id': fld.id + '1',
					'name': fld.name + '1',
					'value': historyValue,
					'aria-label': fld.title,
					'data-type': 'number'
				})
					.keypress(this.numbersOnly);

				if (fld?.range === true) {
					$i1.attr('data-range', true);
				}

				$divApd = $('<div>', { 'class': 'input-group-append' });
				$s = $('<span>', { 'class': 'input-group-text', 'style': 'border-right:0px;' }).text('To');

				highlightCriteria = '';
				historyValue = '';

				if (sessionStorage && sessionStorage.getItem(fld.id + '2')) {
					highlightCriteria = ' highlightCriteria';
					historyValue = sessionStorage.getItem(fld.id + '2');
				}
				$i2 = $("<input>", {
					'type': 'text',
					'class': inputClass + highlightCriteria,
					'id': fld.id + '2',
					'name': fld.name + '2',
					'value': historyValue,
					'aria-label': fld.title,
					'data-type': 'number'
				})
					.keypress(this.numbersOnly);

				if (fld?.range === true) {
					$i2.attr('data-range', true);
				}

				$div.append($i1);
				$divApd.append($s);
				$div.append($divApd);
				$div.append($i2);
				$elem.append($div);
			} else {
				$i = $("<input>", {
					'type': 'text',
					'class': inputClass + highlightCriteria,
					'id': fld.id,
					'name': fld.name,
					'aria-label': fld.title,
					'value': historyValue,
				})
					.keypress(this.numbersOnly);
				$elem.append($i);
			}
			break;
		case "select-native":
			$select = $("<select>", {
				'class': inputClass,
				'id': fld.id, 'name': fld.name,
				'multiple': '',
				'data-show-subtext': fld.subtext,
				'data-live-search': fld.searchable,
				'data-actions-box': fld.selectall
			});
			if (!fld.multiple) $select.removeAttr('multiple');
			$elem.append($select);
			this.replaceSelectOptions($select, fld.lookupvals);
			this.fetchLookups($select, fld);
			break;
		case "chosen":
			$select = $("<select>", {
				'class': inputClass + ' chosen',
				'id': fld.id, 'name': fld.name,
				'multiple': '',
				'data-show-subtext': fld.subtext,
				'data-live-search': fld.searchable,
				'data-actions-box': fld.selectall
			});
			if (!fld.multiple) $select.removeAttr('multiple');
			$elem.append($select);
			$select.chosen({
				search_contains: true,
				disable_search: (!fld.searchable),
				allow_single_deselect: true,  		
				hide_results_on_select: false, 		
				display_selected_options: true, 	
				width: "100%",
				height: "100%"
			});
			this.replaceSelectOptions($select, fld.lookupvals);
			this.fetchLookups($select, fld);
			break;
		case "select":
		case "bootstrap-select":

			$select = $("<select>", {
				'class': inputClass + ' selectpicker',
				'id': fld.id,
				'name': fld.name,
				'multiple': '',
				'data-show-subtext': fld.subtext,
				'data-live-search': fld.searchable,
				'data-actions-box': fld.selectall,
				'data-size': fld.maxheight,
				'data-virtual-scroll': 'true', 
				'data-container': 'body'
			});
			if (data_default_selected) {
				$select.attr('data-default-selected', data_default_selected);
			}
			if (fld.multiple) $select.removeAttr('data-max-options');
			if (!fld.multiple) $select.removeAttr('multiple');
			$elem.append($select);
			$select.selectpicker(); 
			this.replaceSelectOptions($select, fld.lookupvals);
			this.fetchLookups($select, fld);
			break;
		case "date":
			if (fld.range) {
				highlightCriteria = '';
				historyValue = '';
				if (sessionStorage && sessionStorage.getItem(fld.id + '1')) {
					highlightCriteria = ' highlightCriteria';
					historyValue = sessionStorage.getItem(fld.id + '1');
				}
				$div = $("<div>", { 'class': 'input-daterange input-group ' + inputGroupClass + ' nowrap', 'id': 'datepicker' });
				$i1 = $("<input>", {
					'type': 'text',
					'class': inputClass + highlightCriteria,
					'id': fld.id + '1',
					'name': fld.name + '1',
					'data-provide': 'datepicker',
					'data-date-autoclose': 'true',
					'data-range-ordinal': '1',
					'data-type': 'date',
					'value': historyValue,
					'data-date-format': 'mm/dd/yyyy',
					'todayHighlight': 'true',
					'data-date-clear-btn': 'true'
				}).datepicker();
				$divApd = $('<div>', { 'class': 'input-group-append' });
				$s = $('<span>', { 'class': 'input-group-text', 'style': 'border-right:0px;' }).text('To');
				highlightCriteria = '';
				historyValue = '';
				if (sessionStorage && sessionStorage.getItem(fld.id + '2')) {
					highlightCriteria = ' highlightCriteria';
					historyValue = sessionStorage.getItem(fld.id + '2');
				}
				$i2 = $("<input>", {
					'type': 'text',
					'class': inputClass + highlightCriteria,
					'id': fld.id + '2',
					'name': fld.name + '2',
					'data-provide': 'datepicker',
					'data-date-autoclose': 'true',
					'data-range-ordinal': '2',
					'data-type': 'date',
					'value': historyValue,
					'data-date-format': 'mm/dd/yyyy',
					'todayHighlight': 'true',
					'data-date-clear-btn': 'true'
				}).datepicker();
				$div.append($i1);
				$divApd.append($s);
				$div.append($divApd);
				$div.append($i2);
				$elem.append($div);
			} else {
				$i = $("<input>", {
					'type': 'text',
					'class': inputClass + highlightCriteria,
					'id': fld.id,
					'name': fld.name,
					'data-date-autoclose': 'true',
					'data-date-clear-btn': 'true'
				}).datepicker();
				$elem.append($i);
			}
			break;
		case "checkbox":
			break;
		case "text_tt":
			var typeahead = " typeahead";
			var tt_scroll = false;
			var $divtt = undefined;

			if (tt_scroll)
				$divtt = $("<div>", { 'class': 'tt-scrollable-dropdown-menu' });

			$input = $("<input>", {
				'type': 'text',
				'id': fld.id,
				'name': fld.name,
				'class': inputClass + highlightCriteria + typeahead,
			})
				.on('input', this.noFloatingAsterisk);

			if (fld.placeholder.length > 0) {
				$input.attr('placeholder', placeholder);
			}
			if (historyValue.length > 0) {
				$input.attr('value', historyValue);
			}
			if ($divtt !== undefined) {
				$divtt.append($input);
				$elem.append($divtt);
			} else {
				$elem.append($input);
			}
			break;
		default:
			$input = $("<input>", {
				'type': 'text',
				'id': fld.id,
				'name': fld.name,
				'placeholder': placeholder,
				'class': inputClass + highlightCriteria,
			})
				.on('input', this.noFloatingAsterisk);

			if (historyValue.length > 0) {
				$input.attr('value', historyValue);
			}
			$elem.append($input);
			break;
	}

	var $checkbox_id = '';
	var checked = false;
	var checkfield = '';
	var isDisabled = fld.resultorder === null ? false : true;
	checked = isDisabled ? true : false;

	if (fld.type === 'number' || fld.type === 'date' && fld.range) {
		$checkbox_id = fld.id.replace('[]', '') + '1_include_field';
		checkfield = fld.id + '1_include_field';
	} else {
		$checkbox_id = fld.id.replace('[]', '') + '_include_field';
		checkfield = fld.id + '_include_field';
	}
	if (!isDisabled && (sessionStorage && sessionStorage.getItem(checkfield))) {
		checked = true;
	}
	var $help = $("<div>", {
		'class': helpClass + ' custom-control custom-checkbox'
	});
	var $checkbox = $("<input>", {
		'type': 'checkbox',
		'id': $checkbox_id,
		'name': $checkbox_id,
		'class': 'custom-control-input',
		'checked': checked,
		'aria-checked': checked,
		'aria-labelledby': $checkbox_id,
		'disabled': isDisabled
	});
	$help.append($checkbox);

	var $label = $("<label>", {
		'for': $checkbox_id,
		'class': 'custom-control-label'
	}).text(fld.help);

	$help.append($label);
	$elem.prepend($help);

	return $elem;
}; 

bsFormBuilder.prototype.createForm = function () {

	var index = 0;
	var length = this.options.fields.length;
	var colMax = this.options.maxColumns;
	var colCount = colMax + 1;
	var $elem = $(this.options.parent);
	var $row;
	var rowClass = "row form-group";
	var tt = "";

	switch (this.options.size) {
		case "small":
			rowClass += " form-group-sm";
			break;
		case "large":
			rowClass += " form-group-lg";
			break;
	}
	for (index = 0; index < length; index++) {
		var fld = this.options.fields[index];
		if (((colCount + fld.size) > colMax) || (fld.rowbreak == 'before')) {
			colCount = 0;
			$row = $('<div>', { "class": rowClass });
			$elem.append($row);
		} else if (fld.rowbreak == 'after') {
			colCount = colMax + 1;
		}
		$row.append(this.createField(fld));

		if (fld.type === "text_tt") {
			var options = {
				field: fld.id,
				sql: fld.typeaheadsql,
				typeaheadvals: fld.typeaheadvals
			};
			tt = new bsTypeAheadBuilder(options);
			tt.createTypeAhead();
		}

		if (sessionStorage && sessionStorage.getItem(fld.id)) {
			$("#" + fld.id + " + button")
				.removeClass("btn-light")
				.addClass("highlightCriteria");
		} else {
			var att = $('#' + fld.id).attr('data-default-selected');
			if (att == undefined) {
			} else {
				$("#" + fld.id + " + button")
					.removeClass("btn-light")
					.addClass("highlightCriteria");
			}
		}
		colCount += fld.size;
	}
}; 

function bsTabFormBuilder(options) {
	this.options = options;
	this.options.onreset = resetOptions;
}

bsTabFormBuilder.prototype.getOrCreateTabRoot = function (parent) {
	var tabRoot = parent.find(".tab-content");
	if (tabRoot.length == 0) {
		tabRoot = $("<div>", { id: 'tabPanes', "class": 'tab-content clearfix' });
		parent.append(tabRoot);
	}
	return tabRoot;
};

bsTabFormBuilder.prototype.getOrCreateNavRoot = function (parent) {
	var navRoot = parent.find(".nav");
	if (navRoot.length == 0) {
		navRoot = $("<ul>", { id: 'navMenu', "class": 'nav nav-pills' });
		parent.append(navRoot);
	}
	return navRoot;
};

function updateDefaultSelectedNavTabCounts(defs, $parent) {

	var defs = $parent.find("[data-default-selected]");
	if (defs.length > 0) {
		for (var i = 0, t = defs.length; i < t; i++) {
			var id = $('#' + defs[i].id);
			if (id) {

				$("#" + defs[i].id + " + button").addClass("highlightCriteria");

				var tab = $(defs[i]).closest(".tab-pane");
				if (tab.length > 0) {
					var navs = $parent.find("ul.nav.nav-pills a");
					var criteria = tab.find('input[id],select[id]').not("input:checkbox").filter(function () {
						return !!this.value;
					});
					$("#" + navs[i].id + " span.badge")
						.removeClass('d-none')
						.addClass("show")
						.text(criteria.length);
				}
			}
		}
	} 
} 

function selectAllRolltypeOptions() {

	var rt = $('#RollType').find("option");
	if (rt?.length > 0) {

		var n = 0;
		for (var i = 0; i < rt.length; i++) {
			if (rt[i].selected) n++;
		}
		if (n !== rt?.length)
			$('#RollType').selectpicker('selectAll');

		return;
	}
} 

bsTabFormBuilder.prototype.monitorInput = function () {

	var $parent = $(this.options.parent);
	var myoptions = this.options;
	var $form = $parent;

	if (($form.length == 0) || ($form[0].nodeName != 'FORM')) {
		$form = $parent.find("form");
	}
	if (($form.length == 0) || ($form[0].nodeName != 'FORM')) {
		$form = $parent.closest("form");
	}
	if (($form.length == 0) || ($form[0].nodeName != 'FORM')) {
		throw "Unable to locate form element.";
	}
	$('.selectpicker').on('refreshed.bs.select', function (e) {
		var tab = $(e.target).closest(".tab-pane");
		if (tab.length > 0) {
			var navs = $parent.find("ul.nav.nav-pills a");
			var tabs = $parent.find(".tab-pane");
			for (var i = 0, l = tabs.length; i < l; i++) {
				if (tabs[i].id === tab[0].id) {
					if ($(this).hasClass('selectpicker')) {
						var selects = $("option:selected", this);
						if (selects.length > 0) {
							var badge = $("#" + navs[i].id + " span.badge");
							var n = 1;
							if (badge.text() && badge.text().length > 0) {
								n = Number(badge.text());
								n++;
							}
							$("#" + navs[i].id + " span.badge")
								.removeClass('d-none')
								.addClass("show")
								.text(n);
						}
					}
				}
			}
		}
	}); 
	$form.find("button[type='reset'],input[type='reset']").click(function (e) {

		$parent.find("select.selectpicker:not([data-default-selected]) + button.highlightCriteria")
			.removeClass("highlightCriteria")
			.selectpicker('setStyle');

		$parent.find("ul.nav.nav-pills a").each(function (index) {
			var item = $(this);
			item.attr("title", "");
			var text = item.text();
			$("#" + item[0].id + " span")
				.removeClass('show active')
				.addClass('d-none');

			$("#" + item[0].id)
				.removeClass('active');
		});

		$('.nav-pills a:first').tab('show').addClass('active');

		$form.find('input,select')
			.not(":checkbox")
			.not(":button[type=reset]")
			.not(":input[type=reset]")
			.not(":button[type=submit]")
			.not(":input[type=submit]")
			.not('[data-default-selected]')
			.filter(function () {
				if ((!!this.value) && (!!this.name)) {
					this.defaultValue = ''; 
					$("#" + this.id).removeClass("highlightCriteria");
					$("#" + this.id).val('');
					$("#" + this.id).selectpicker('refresh');
				}
				if ($(this).hasClass('typeahead')) {
					$(this).removeClass("highlightCriteria");

					$('.typeahead').removeAttr('value');
					$('.typeahead').typeahead('val', '');

					var style = $(this).attr("style");
					const regex = /rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)/gmi;
					var s = style.replace(regex, 'rgb(255, 255, 255)');
					$(this).attr("style", s);

				}
			});
		if (typeof myoptions.onreset === 'function') {
			myoptions.onreset();
		}
		$('input:checked').not(':disabled').each(function () {
			$('#' + this.id).prop('checked', false);
			$('#' + this.id).removeAttr('checked');
		});

		var dattr = $parent.find("[data-default-selected]");
		dattr.selectpicker('deselectAll');

		if (dattr && dattr.length > 0) {

			var dattrs = dattr.attr("data-default-selected").split(';');
			dattr.selectpicker('val', dattrs);
			updateDefaultSelectedNavTabCounts(dattr, $parent);

		}

		if (sessionStorage) {
			sessionStorage.clear();
		}
		return false; 
	}); 

	$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
		$("#" + e.target.id + " span")
			.addClass("badge-light")
			.removeClass("badge-success");

		var tabsToHideArray = tabsArray.filter(function (f) { return f !== e.target.id; });
		$(tabsToHideArray).each(function (index, value) {
			$("#" + value + " span")
				.removeClass("badge-light")
				.addClass("badge-success");
		});
	}); 

	$form.find("input:checkbox").change(function (e) {
		var tab = $(e.target).closest(".tab-pane");
		if (tab?.length > 0) {
			var isChecked = false;
			var navs = $parent.find("ul.nav.nav-pills a");
			var tabs = $parent.find(".tab-pane");
			for (var i = 0, l = tabs?.length; i < l; i++) {
				if (tabs[i].id === tab[0].id) {
					var id = $(this).attr("id");
					if (id && $("#" + id).prop("checked")) {
						sessionStorage.setItem(id, 'checked');
						isChecked = true;
					} else {
						sessionStorage.removeItem(id);
					}
				}
			}
			if (tab[0]?.id === 'tabTPP' && isChecked)
				selectAllRolltypeOptions();

			return;
		}
	}); 

	$form.find("input[id],select[id]").not("input:checkbox").change(function (e) {
		var tab = $(e.target).closest(".tab-pane");
		if (tab.length > 0) {
			var navs = $parent.find("ul.nav.nav-pills a");
			var tabs = $parent.find(".tab-pane");

			for (var i = 0, l = tabs.length; i < l; i++) {
				if (tabs[i].id === tab[0].id) {


					var id = $(this).attr("id");

					if (id) {

						var criteria = tab.find('input[id],select[id]').not("input:checkbox").filter(function () {
							return !!this.value;
						});

						var bIncludeFieldChecked = false;

						if ($(this).hasClass('selectpicker')) {

							var slecteditems = $(this).find("option:selected");
							var optVals = $("#" + id).val();

							if (!slecteditems.length > 0) {
								if ($("#" + id + " + button").hasClass('highlightCriteria')) {

									$("#" + id + " + button").removeClass("highlightCriteria");
									sessionStorage.removeItem(id, JSON.stringify(optVals));

								}
							} else if (slecteditems.length > 0) {

								if ($(this).hasClass('selectpicker')) {

									$("#" + id + " + button")
										.removeClass("btn-light")
										.addClass("highlightCriteria");

									sessionStorage.setItem(id, JSON.stringify(optVals));
									bIncludeFieldChecked = true;
								}
							}
						} 
						else {
							var fd = $("#" + id);
							if (fd) {
								var f = $("#" + id).val();
								if (!fd.val() && !fd.val().length > 0) {
									$("#" + id).removeClass("highlightCriteria");
									sessionStorage.removeItem(id, f);

									if ($(this).hasClass('tt-input')) {
										tt = $parent.find(".tt-hint");
										if (tt) {
											$(tt).removeClass("highlightCriteria");
										}
									}

								}
								if (!!fd.val().length > 0) {
									$(this).addClass("highlightCriteria");
									sessionStorage.setItem(id, f);
									bIncludeFieldChecked = true;

									if ($(this).hasClass('tt-input')) {
										var tt = $parent.find(".tt-hint");
										if (tt) {
											$(tt).addClass("highlightCriteria");
										}
									}
								}
							}
						} 

						if (bIncludeFieldChecked) {
							sessionStorage.setItem(id + "_include_field", 'checked');
						} else {
							sessionStorage.removeItem(id + "_include_field");
						}



						var temp_id = id;

						const el = document.querySelector(`#${id}`);
						if (el?.dataset.range) {
							temp_id = temp_id.slice(0, -1) + '1';

							var range_item_1 = el.id.slice(0, -1) + '1';
							var range_item_2 = el.id.slice(0, -1) + '2';

							var range_value = document.querySelector(`#${range_item_1}`).value;
							var range_sum_1 = parseFloat(range_value);
							if (Number.isNaN(range_sum_1))
								range_sum_1 = 0;

							range_value = document.querySelector(`#${range_item_2}`).value;
							var range_sum_2 = parseFloat(range_value);
							if (Number.isNaN(range_sum_2))
								range_sum_2 = 0;

							bIncludeFieldChecked = (range_sum_1 + range_sum_2) > 0;
						}

						$(`#${temp_id}_include_field`).not(':disabled').prop('checked', bIncludeFieldChecked);

						if (criteria.length > 0) {
							$("#" + navs[i].id + " span.badge")
								.removeClass('d-none')
								.addClass("show")
								.text(criteria.length); 
							navs[i].title = changeNavTitle(criteria);
						} else {
							$("#" + navs[i].id + " span.badge")
								.removeClass('show')
								.addClass('d-none');
							navs[i].title = '';
						} 

						if (tab[0]?.id === 'tabTPP' && bIncludeFieldChecked)
							selectAllRolltypeOptions();

					} 
					break;
				}
			}
		}
	}); 
}; 

function resetOptions() {
	var table = $('#gridsearch').DataTable();
	if (table) {
		table
			.clear()
			.draw();
	}
} 

var tt_options = {
	field: String,
}; 

function bsTypeAheadBuilder(tt_options) {
	this.options = tt_options;
}

bsTypeAheadBuilder.prototype.createTypeAhead = function () {

	var field = this.options.field;
	var sql = this.options.sql;
	var typeaheadvals = this.options.typeaheadvals;

	var blood = new Bloodhound({

		queryTokenizer: Bloodhound.tokenizers.whitespace,
		datumTokenizer: Bloodhound.tokenizers.whitespace,
		remote: {
			url: "/wp-content/themes/frontier-child/models/pao-model-typeahead.php",
			transform: function (result) {
				return $.map(result, function (item) {
					return {
						value: item
					};
				});
			},
			prepare: function (query, settings) {

				var obj = { "sql": sql, "query": query };
				var json = JSON.stringify(obj);

				settings.dataType = "json";
				settings.data = 'data=' + json;
				settings.type = "POST";
				return settings;
			}
		}
	}); 
	var typeahead = $('.typeahead').typeahead({
		hint: true,
		highlight: true,
		minLength: 3
	},
		{
			name: field,
			source: blood,
			limit: 6,
			displayKey: function (data) {
				var keys = Object.keys(data.value);
				if (keys && keys.length > 0)
					return data.value[keys[0]].trim();
			},
			templates: {
				suggestion: function (data) {
					var keys = Object.keys(data.value);
					if (keys && keys.length > 0) {
						var $p = $("<p>");
						$p.append(data.value[keys[0]].trim());
						if (keys.length > 1) {
							var $it = $("<i>");
							$it.append(data.value[keys[1]]);
							$p.append(", ");
							$p.append($it);
						}
						if (keys.length > 2) {
							if (data.value[keys[2]] !== 'RP') {
								var $sp = $("<span>").addClass('tt-blue');
								$sp.append(' (' + data.value[keys[2]] + ')');
								$p.append($sp);
							}
						}
						return $p;
					}
				}
			}
		})
		.on('typeahead:selected', onSelected);

	function onSelected($e, datum) {
		var _propertytype;
		switch (datum.value.propertytype.toUpperCase()) {
			case 'RP':
				_propertytype = "REAL PROPERTY";
				break;
			case 'PP':
			case 'MH':
				_propertytype = "PERSONAL PROPERTY";
				break;
			case 'CA':
				_propertytype = "CENTRALLY ASSESSED";
				break;
		}
		if (_propertytype?.length > 0) {
			var el = $('#RollType').val();
			if (el === null) {
				$('#RollType').selectpicker('val', _propertytype);
			} else if ($.inArray(_propertytype, el) === -1) {
				el.push(_propertytype);
				$('#RollType').selectpicker('val', el);
			}
		}
		var id = $e.currentTarget.id;
		if (id) {
			var fd = $("#" + id);
			if (fd) {
				if (!!fd.val().length > 0) {
					$(this).addClass("highlightCriteria");
					sessionStorage.setItem(id, fd.val());
				}
			}
		}
	} 

	$('#' + field).attr('autocomplete', 'mcpao-off');

}; 

function changeNavTitle(criteria) {
	var arr = [];
	var s = criteria.serialize().replace(new RegExp('%5B', 'g'), '').replace(new RegExp('%5D', 'g'), '').replace(new RegExp(/\+/, 'g'), ' ');
	var items = s.split('&');

	for (var a = 0; a < items.length; a++) {
		var kv = items[a].split('=');
		var key = kv[0];
		var value = kv[1];
		if (key in arr) {
			arr[key].push(value);
		} else {
			arr[key] = [value];
		}
	}
	s = '';
	for (key in arr) {
		if (s.length > 0) s = s + '\n';
		if (arr[key].length > 5)
			s = s + key + ' in ( *' + arr[key].length + ' selected* )';
		else if (arr[key].length > 1)
			s = s + key + ' in (' + arr[key].join(',') + ')';
		else
			s = s + key + ' = ' + arr[key][0];
	}
	return s;
}


bsTabFormBuilder.prototype.createTabs = function () {
	var $parent = $(this.options.parent);
	var $navRoot = this.getOrCreateNavRoot($parent);
	var $tabRoot = this.getOrCreateTabRoot($parent);
	var $newNav;
	var $active;
	var $newTab;
	var $badgeColor;
	var hasSessionStorage = false;

	if (sessionStorage && sessionStorage.length > 0) {
		hasSessionStorage = true;
	}

	for (var t in this.options.tabs) {
		var tab = this.options.tabs[t];

		$newNav = $("<li>", { "class": 'nav-item ml-1 mr-1' });

		$active = tab.active ? 'active' : '';
		$badgeColor = tab.active ? 'light' : 'success';

		$newTab = $("<div>")
			.addClass("tab-pane " + $active)
			.attr("id", tab.tabid);

		$newNav.append('<a class="flex-sm-fill text-sm-center nav-link ' + $active + '" href="#' + tab.tabid +
			'" id="' + tab.navid + '" data-toggle="tab">' + tab.text + ' <span class="badge badge-' + $badgeColor + '"></span></a>');

		$navRoot.append($newNav);
		$tabRoot.append($newTab);

		if ('form' in tab) {
			var bs = new bsFormBuilder(tab.form);
			bs.createForm();
			if (hasSessionStorage) {
				var criteria = $('#' + tab.tabid).find('input,select').not("input:checkbox").filter(function () {
					var id = this.id;
					if (typeof $(this).data('data-range-ordinal') !== 'undefined') {
						id += $(this).data('data-range-ordinal');
					}
					if (sessionStorage.getItem(id)) {
						return !!this.value;
					}
				});
				if (criteria.length > 0) {
					$('#' + tab.navid + " span")
						.removeClass('d-none')
						.addClass("show")
						.text(criteria.length);
				}
			}
		}
		tabsArray.push(tab.navid);
	}
	this.monitorInput();

	var defs = $parent.find("[data-default-selected]");
	updateDefaultSelectedNavTabCounts(defs, $parent);

}; 